import { render } from "./StatsWidgetData.vue?vue&type=template&id=28e152ae&scoped=true"
import script from "./StatsWidgetData.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetData.vue?vue&type=script&lang=ts"

import "./StatsWidgetData.vue?vue&type=style&index=0&id=28e152ae&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-28e152ae"

export default script